import AuthForm from "../features/auth/AuthForm";
import HeroImg from "../assets/images/hero-1.jpg";

const SignUp = () => {
  return (
    <AuthForm
      type="register"
      title="Create Account"
      subtitle="Sign up with your mobile number to get started"
      image={HeroImg}
      footerText="Already have an account?"
      footerLink="Login"
      footerPath="/login"
      userType="CUSTOMER"
    />
  );
};

export default SignUp;
